import util from '../util'

let controller = 'OperadorFrontEndContaNotificacao'
export default Object.assign({}, util.GetCrud(controller, null), {
})